import { EXPERTISE } from "../../data/content";
import { Reveal } from "./Reveal";

export default function Expertise() {
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="py-24 md:py-32 bg-secondary"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="font-mono-accent text-xs uppercase tracking-[0.22em] text-accent mb-5">
                Other services
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-serif-display font-medium tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
                {EXPERTISE.heading}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-5">
            <p className="text-base md:text-lg leading-relaxed text-foreground/70">
              {EXPERTISE.intro}
            </p>
          </Reveal>
        </div>

        {/* Highlighted service cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-foreground/15 border border-foreground/15">
          {EXPERTISE.items.map((item, i) => (
            <Reveal key={i} delay={(i % 3) * 0.06}>
              <div
                data-testid={`expertise-item-${i}`}
                className="group relative bg-background h-full p-8 md:p-10 flex flex-col transition-colors duration-500 hover:bg-primary"
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono-accent text-sm text-accent">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-mono-accent text-lg text-accent opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500">
                    &rarr;
                  </span>
                </div>
                <h3 className="mt-8 font-serif-display text-2xl md:text-[1.7rem] leading-tight transition-colors duration-500 group-hover:text-primary-foreground">
                  {item.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-foreground/65 transition-colors duration-500 group-hover:text-primary-foreground/75">
                  {item.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
